// HeroSection.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
/*import useCountAnimation from '../hooks/useCountAnimation';*/
import { FaArrowRight, FaRobot, FaDiscord, FaCalculator, FaDatabase, FaGraduationCap } from 'react-icons/fa';
import styles from './HeroSection.module.css';
/*import screenshot from '../assets/sportsbet-conversion-example.png';*/

const HeroSection = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  /*
  const stats = [
    { value: 1000, prefix: '', suffix: '+', label: 'Happy Users' },
    { value: 1, prefix: '$', suffix: 'M+', label: 'Total Winnings' },
    { value: 12, prefix: '', suffix: '+', label: 'Bookmakers Supported' },
  ];
  */
  
  const handleStartNowClick = () => {
    if (user && user?.discord_user_id) {
      window.location.href = 'https://discord.com/channels/1225323622776963072/1225332405729099897';
    } else if (user) {
      navigate('/dashboard');
    } else {
      navigate('/signup');
    }
  };

  const handleLearnMoreClick = () => {
    const featuresSection = document.getElementById('features-section');
    if (featuresSection) {
      featuresSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const bookmakers = [
    'Sportsbet', 'Betr', 'Betright', 'Ladbrokes', 'Neds',
    'Playup', 'Pointsbet', 'TAB', 'TabTouch',
    'TopSport', 'Unibet', 'Betfair'
  ];

  const features = [
    {
      icon: <FaRobot />,
      title: 'Automated Value Detection',
      description: 'Bots that save you time by finding arbs, EV opportunities, and conversion data while automatically calculating optimal stakes.',
      size: 'large',
      gradient: 'blue'
    },
    {
      icon: <FaGraduationCap />,
      title: 'Educational Resources',
      description: 'Master betting strategies with our comprehensive learning resources and expert guidance.',
      size: 'small',
      gradient: 'purple'
    },
    {
      icon: <FaDiscord />,
      title: 'Discord Integration',
      description: 'Get alerts and updates directly in Discord with our seamless integration.',
      size: 'small',
      gradient: 'indigo'
    },
    {
      icon: <FaCalculator />,
      title: 'Advanced Calculators',
      description: 'Sophisticated tools for calculating optimal bet sizes and strategies.',
      size: 'small',
      gradient: 'cyan'
    },
    {
      icon: <FaDatabase />,
      title: 'Bookmaker Database',
      description: 'Access our comprehensive database of bookmaker information and odds.',
      size: 'small',
      gradient: 'teal'
    }
  ];

  return (
    <>
      <div className={styles.heroContainer}>
        <div className={styles.heroContent}>
          <h1>Bet Smarter, Win Bigger, Scale Faster</h1>
          <p className={styles.heroSubtitle}>
            Maximize your returns with our data-driven bots and expert insights. 
            Gain an edge with advanced automation tools designed for smarter betting.
          </p>
          <div className={styles.buttonGroup}>
            <button className={styles.startButton} onClick={handleStartNowClick}>
              START NOW!
            </button>
            <button className={styles.learnMoreButton} onClick={handleLearnMoreClick}>
              LEARN MORE <FaArrowRight />
            </button>
          </div>
        </div>
      </div>

      <div className={styles.rotatingBanner}>
        <h3 className={styles.bannerTitle}>Our specialized bots support</h3>
        <div className={styles.marquee}>
          <div className={styles.marqueeTrack}>
            {[...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers, ...bookmakers].map((bookmaker, index) => (
              <div key={index} className={styles.bookmakerCard}>
                {bookmaker}
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className={styles.features} id="features-section">
        <div className={styles.featuresContent}>
          <h2>Powerful Features</h2>
          <p className={styles.subtitle}>Everything you need to succeed</p>

          <div className={styles.bentoGrid}>
            {features.map((feature, index) => (
              <div
                key={index}
                className={`${styles.bentoBox} ${styles[feature.size]} ${styles[feature.gradient]}`}
              >
                <div className={styles.bentoContent}>
                  <div className={styles.iconWrapper}>
                    {feature.icon}
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;